import {
    LOAD_UNALLOCATED_FREELANCERS,
    LOADED_UNALLOCATED_FREELANCERS_SUCCESS,
    LOADED_UNALLOCATED_FREELANCERS_FAILURE,
    SET_SELECTED_UNALLOCATED_FREELANCERS,
} from '../actions';


const initialState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: undefined,
    selectedUnallocatedFreelancers: [],
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_UNALLOCATED_FREELANCERS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOADED_UNALLOCATED_FREELANCERS_SUCCESS:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case LOADED_UNALLOCATED_FREELANCERS_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case SET_SELECTED_UNALLOCATED_FREELANCERS:
            return {
                ...state,
                selectedUnallocatedFreelancers: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;
